module.exports = __webpack_public_path__ + "static/img/HCA.caa6dee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HCA.png
// module id = T0NC
// module chunks = 1